import { BaseFieldRenderer } from './base-field-renderer';
import { UrlFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class UrlFieldRenderer extends BaseFieldRenderer<UrlFieldJsonData> {
    protected override get defaultData(): UrlFieldJsonData {
        return {
            id: '',
            type: 'url',
            label: TranslateUtils.URL_FIELD.LABEL,
            placeholder: TranslateUtils.URL_FIELD.PLACEHOLDER,
            description: '',
            required: false,
            hiddenLabel: false
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: UrlFieldJsonData, options: RenderOptions): HTMLElement {
        const input = document.createElement('input');
        input.classList.add('input', 'default');
        input.type = 'text';
        input.maxLength = 2048;

        this.applyCommonAttributes(input, fieldJsonData);

        return input;
    }
}
